module.exports = __webpack_public_path__ + "img/公司官网_关于我们 手机端.99c15e66.png";